import React from "react";
export function XIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.05047 0.81604L5.33172 1.22522L8.78289 6.23987L9.32879 7.03284L14.154 14.0426L15.1725 15.5231H10.9665L10.6843 15.1139L6.99676 9.75647L6.45184 8.96448L1.86199 2.29651L0.843437 0.81604H5.05047ZM2.62957 1.76917L7.07488 8.22717V8.22815L7.62078 9.02014L11.4509 14.5865L11.4772 14.6237V14.5924H13.402L13.3864 14.5699L8.70574 7.76819L8.15984 6.9762L4.56512 1.75256L4.57391 1.7467H2.61395L2.62957 1.76917Z"
        fill="#575757"
        stroke="#575757"
        strokeWidth="0.0284186"
      />
      <path
        d="M7.61446 9.01056L6.97481 9.75568L2.0168 15.5233H0.831253L6.45137 8.98224L7.08516 8.242L7.61446 9.01056Z"
        fill="#575757"
        stroke="#575757"
        strokeWidth="0.0284186"
      />
      <path
        d="M14.6898 0.801392L9.34067 7.02442L8.69409 7.77663L8.14854 6.98426L8.79512 6.23155L12.4186 2.01423L13.466 0.801392H14.6898Z"
        fill="#575757"
      />
    </svg>
  );
}
export default XIcon;
